import { createAction } from 'deox';
export const resetApplication = createAction('RESET_APPLICATION');
